<template>
    <v-row no-gutters class="pb-1">
        <v-col cols="12" md="4" class="pe-1">
            <v-autocomplete
                label="Item"
                dense
                v-model="line.item_id"
                :items="items"
                :rules="[isRequired]"
                @update:search-input="itemSearch"
                item-text="display_name"
                item-value="id"
                outlined
                hide-details="auto">
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-select
                label="Unit"
                :items="measureUnits"
                item-text="abbreviation"
                :rules="[isRequired]"
                v-model="line.measure_unit_id"
                item-value="id"
                dense
                outlined
                hide-details="auto">
            </v-select>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
                label="Quantity"
                v-model="line.quantity"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details="auto">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
                label="Price"
                dense
                v-model="line.price"
                :rules="[isRequired, isNumeric]"
                outlined
                hide-details="auto">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pe-1">
            <v-text-field
                label="Subtotal"
                dense
                outlined
                :value="subtotal"
                :suffix="currency ? currency.abbreviation : null"
                background-color="disabled"
                disabled
                hide-details="auto">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-select
                label="Tax"
                dense
                v-model="line.tax_id"
                :items="taxRates"
                :rules="[isRequired]"
                item-text="name"
                item-value="id"
                outlined
                hide-details="auto">
            </v-select>
        </v-col>
        <!-- <v-col cols="12" md="1" class="pe-1">
            <v-autocomplete
                label="Tax"
                dense
                :items="taxRates"
                item-text="name"
                item-value="id"
                v-model="line.tax_id"
                :rules="[isRequired]"
                @update:search-input="TaxRatesSearch"
                outlined
                hide-details="auto">
            </v-autocomplete>
        </v-col> -->
        <v-col cols="12" md="2" >
            <div class="d-flex justify-center align-center">
                <v-text-field
                    label="Total"
                    dense
                    :value="total"
                    :suffix="currency ? currency.abbreviation : null"
                    outlined
                    background-color="disabled"
                    disabled
                    hide-details="auto">
                </v-text-field>
                <v-btn icon @click="deleteLine">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRequired, isNumeric } from './../../utils/validations';

export default {
    name: "PurchaseOrderFormLine",
    props: {
        value: Object,
        index: Number,
        currency: Object
    },
    data() {
        return {
            line: {...this.value},
        }
    },  
    watch: {
        line: {
            deep: true,
            handler(val) {
                this.$emit('input', {...val, subtotal: this.subtotal, tax: this.taxAmount, total: this.total})
            }
        }
    },
    computed: {
        ...mapGetters({
            items: "purchase/item/list",
            itemsLoading: "purchase/item/loading",
            taxRates: "purchase/tax/list",
        }),
        subtotal() {
            let subtotal = this.line.quantity * this.line.price;
            return isNaN(subtotal) ? 0 : subtotal ;
        },
        taxAmount() {
            let tax = this.taxRates.find(e => e.id == this.line.tax_id);
            if(!tax) return 0;
            let taxAmount = this.subtotal * tax.rate;
            return isNaN(taxAmount) ? 0 : taxAmount ;
        },
        total() {
            let total = this.subtotal + this.taxAmount;
            return isNaN(total) ? 0 : total;
        },
        measureUnits() {
            let currentItem = this.items.find(e => e.id == this.line.item_id);
            return currentItem ? currentItem.measure_units : [];
        }
    },
    methods: {
        isRequired, isNumeric,
        ...mapActions({
            itemSearch: "purchase/item/search"
        }),
        deleteLine() {
            this.$emit("delete:line", this.index)
        }
    },
    updated() {
        this.$emit('input', {...this.value, subtotal: this.subtotal, tax: this.taxAmount, total: this.total});
    }
}
</script>

<style>

</style>